module.exports = __webpack_public_path__ + "img/53400.e0075d09.jpg";